import { render, staticRenderFns } from "./ProjectResourceTree.vue?vue&type=template&id=9c6c6fa2"
import script from "./ProjectResourceTree.vue?vue&type=script&lang=js"
export * from "./ProjectResourceTree.vue?vue&type=script&lang=js"
import style0 from "./ProjectResourceTree.vue?vue&type=style&index=0&id=9c6c6fa2&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports